import {
    ArchiveStatus,
} from 'app/enums/common.enums'

const applyArchived = (cb) => {
    return (params) => {
        const {
            data: paramsData,
            archived,
        } = params

        let data = {
            ...paramsData,
        }

        if (archived) {
            data = {
                ...data,
                archived,
                archiveStatus: ArchiveStatus.ARCHIVED,
            }
        }

        return cb({
            ...params,
            data,
        })
    }
}

export default applyArchived
